// extracted by css-extract-rspack-plugin
export default {"editableChip":"VN4UYTVGmAdfW2f7","chip":"CyZkEcIUiOcl9zkr","loadingIndicator":"yBwePz3EijUsPUcT","removeButton":"zs2wA3ixowwp33qz"};